import React from 'react';

import { Flex, Heading } from '@rover/kibble/core';
import type { Image } from '@rover/rsdk/src/apiClient/latest/model/image';
import type { TrainerEducation } from '@rover/rsdk/src/apiClient/latest/model/trainerEducation';
import { TrainerProfileDetailsMethodology } from '@rover/rsdk/src/apiClient/latest/model/trainerProfileDetailsMethodology';

import MethodologySection from './Methodology/MethodologySection';
import QualificationsSection from './Qualifications/QualificationsSection';
import YearsOfExperience from './YearsOfExperience';

type MoreInfoSectionProps = {
  methodology?: TrainerProfileDetailsMethodology;
  methodologyCustom?: string;
  methodologyDetails?: string;
  yearsOfTraining: number;
  educationList: TrainerEducation[];
  name: string;
  defaultImage: Image;
};

const MoreInfoSection: React.FC<MoreInfoSectionProps> = (props) => {
  const {
    methodology,
    methodologyCustom,
    methodologyDetails,
    yearsOfTraining,
    educationList,
    name,
    defaultImage,
  } = props;

  return (
    <Flex flexDirection="column" data-testid="more-info-section">
      <Heading size="400" webProps={{ responsive: false }} mb="6x">
        More info
      </Heading>

      <Flex flexDirection="column" gap="10x">
        <YearsOfExperience yearsOfTraining={yearsOfTraining} isTrainerProfileReordering />

        <MethodologySection
          methodology={methodology}
          methodologyCustom={methodologyCustom}
          methodologyDetails={methodologyDetails}
          name={name}
          defaultImage={defaultImage}
          isTrainerProfileReordering
        />
        <QualificationsSection
          educationList={educationList}
          name={name}
          isTrainerProfileReordering
        />
      </Flex>
    </Flex>
  );
};

export default MoreInfoSection;
